

export default {
  title1: 'Wuxi Kelke instrument Valve Co., LTD',
  title2: 'No.6, Daoyu Road, Houzhai, Hongshan Town, Xinwu District, Wuxi City, Jiangsu Province, China',
  callMe: {
    title: 'Contact us',
    list: [
      `Phone/Wechat: +86-13951576318(China)`,
      `Phone/WhatsApp: +1-7788738683(0versea)`,
      `Email: info@kelkflow.com.cn`,
      // `WhatsApp: +1-7788738683`,
      // `Or directly add customer service contact`,
    ]
  },
  imgList: [
    {
      icon: require("@/assets/images/callMe/haiwai_01.png"),
      qrIcon: '',
      name: '',
      selectIcon: '',
      link: '',
      isShow:false
    },
    {
      icon: require("@/assets/images/callMe/haiwai_02.png"),
      qrIcon: '',
      name: '',
      selectIcon: '',
      link: '',
      isShow:false
    },
    {
      icon: require("@/assets/images/callMe/haiwai_03.png"),
      qrIcon: '',
      name: '',
      selectIcon: '',
      link: '',
      isShow:false
    },
    {
      icon: require("@/assets/images/callMe/haiwai_04.png"),
      qrIcon: '',
      name: '',
      selectIcon: '',
      link: '',
      isShow:false
    }
  ],
  qrcodeList: [
    
    {
      icon: require("@/assets/images/public/i4.png"),
      selectIcon: require("@/assets/images/callMe/4-4.png"),
      qrIcon: require("@/assets/images/public/i11.png"),
      name: "WeCom",
      seen: false
    },
    {
      icon: require("@/assets/images/public/i5.png"),
      selectIcon: require("@/assets/images/callMe/5-5.png"),
      qrIcon: require("@/assets/images/public/i11.png"),
      name: "WeChat customer service",
      seen: false
    }
  ],
  phoneTxt: '24/7 Call line (Chinese)',
  attentionOurTxt: 'Follow us',
  copyrightTxt: 'Wuxi Kelke Instrument Valve Co., LTD. All rights reserved. Record No. Su ICP 20021752',
}


// WEBPACK FOOTER //
// ./src/config/lang/en/footer.js